module.exports = __webpack_public_path__ + "static/media/ourProperties.84495baa.svg";